import { configurationVariables } from "../environment/index";

const urlApi = configurationVariables.UrlApi;

export default urlApi;